import InstitutionalHero from "components/Institutional/InstitutionalHero";
/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultNavbar from "components/Institutional/InstitutionalNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/bg-instituto.jpg";
// import logoLargo from "assets/images/logoGrande.jpg";
import { ContenedorPrincipal } from "components/ContenedorPrincipal";
import Counters from "./sections/Counters";
import Historia from "./sections/Historia";
import Actividades from "./sections/Actividades";
// import Information from "./sections/Information";
// import DesignBlocks from "./sections/DesignBlocks";
// import Pages from "./sections/Pages";
import Niveles from "./sections/Niveles";
import Pages from "./sections/Pages";
import BotonWsp from "components/BotonWsp";

function Presentation() {
  return (
    <MKBox position="relative">
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "https://www.creative-tim.com/product/material-kit-react",
          label: "free download",
          color: "info",
        }}
        sticky
        brand={"Instituto Sagrado Corazón"}
      />
      {/* <Grid container display="flex" alignItems="center" justifyContent="center">
        <Grid p={1} xs={12} sm={12} md={6}>
          <MKBox
            component="img"
            src={logoLargo}
            alt={"Logo institucional"}
            width="100%"
            mt={8}
            borderRadius="lg"
          />
        </Grid>
      </Grid> */}
      <InstitutionalHero
        image={bgImage}
        title="Instituto Sagrado Corazón de Jesús"
        subtitle="Villa Mercedes, San Luis, Argentina."
        home
      />
      <ContenedorPrincipal>
        <Counters />
        <Niveles />
        <Historia />
        <Actividades />
        <Pages />
      </ContenedorPrincipal>

      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
      <BotonWsp />
    </MKBox>
  );
}

export default Presentation;
